import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { ColumnToggle } from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";

const { ToggleList } = ColumnToggle;

const RemotePagination = (props) => {
  const { data, columns, page, sizePerPage, onTableChange, totalSize, enableSearch, sortField, sortOrder, initialSearchText } = props;
  const activeSortProp = sortField ? { dataField: sortField, order: sortOrder || 'asc' } : undefined;
  const [displaySearch, setDisplaySearch] = useState(false);
  const [searchText, setSearchText] = useState(initialSearchText || "");
  const [customColumns, setCustomColumns] = useState(columns || []);

  const paginationOptions = {
    totalSize: totalSize,
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "300",
        value: 300,
      },
    ],
  };

  useEffect(() => {
    setDisplaySearch(enableSearch);
  }, [enableSearch]);

  // Sync customColumns with incoming columns while preserving current hidden states
  useEffect(() => {
    if (!columns || columns.length === 0) {
      setCustomColumns([]);
      return;
    }
    setCustomColumns((prev) => {
      if (!prev || prev.length === 0) return columns;
      const hiddenByKey = new Map();
      prev.forEach((c) => {
        if (typeof c?.dataField !== "undefined") hiddenByKey.set(c.dataField, c.hidden);
      });
      return columns.map((c) => {
        const hasKey = typeof c?.dataField !== "undefined" && hiddenByKey.has(c.dataField);
        return hasKey ? { ...c, hidden: hiddenByKey.get(c.dataField) } : c;
      });
    });
  }, [columns]);

  const onSearchChange = (e) => {
    const type = "search";
    const filters = {
      searchText: e.target.value,
    };
    setSearchText(e.target.value);

    onTableChange(type, filters);
  };

  const handleTableChange = (type, newState) => {
    if (type === "sort" && newState.sortField !== sortField) {
      const sortedColumn = columns.find((column) => column.dataField === newState.sortField);
      if (sortedColumn?.defaultSortOrder) {
        return onTableChange(type, { ...newState, sortOrder: sortedColumn.defaultSortOrder });
      }
    }
    return onTableChange(type, newState);
  };

  const onCustomColumnToggle = (column) => {
    // Toggle column visibility
    const updatedColumns = customColumns.map((col) => {
      if (col.dataField === column) {
        return { ...col, hidden: !col.hidden };
      }
      return col;
    });
    setCustomColumns(updatedColumns);
  };
  return (
    <ToolkitProvider keyField="_id" data={data} columns={customColumns} columnToggle search filter>
      {(toolkitprops) => (
        <React.Fragment>
          {displaySearch && (
            <div className="d-flex justify-content-end">
              <input className="form-control" onChange={onSearchChange} value={searchText} />
            </div>
          )}
          <ToggleList
            className="d-flex justify-content-center mt-4"
            {...toolkitprops.columnToggleProps}
            onColumnToggle={onCustomColumnToggle}
          />
          <BootstrapTable
            sort={activeSortProp}
            defaultSortDirection="asc"
            striped
            hover
            remote
            condensed
            keyField="_id"
            data={data}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            cellEdit={cellEditFactory({ mode: "click", blurToSave: true, afterSaveCell: onTableChange })}
            {...toolkitprops.baseProps}
          />
        </React.Fragment>
      )}
    </ToolkitProvider>
  );
};

export default RemotePagination;
